import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "ce-246-247-class"
    }}>{`Class changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Authorization\\Model\\CompositeUserContext`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Authorization\\Model\\CompositeUserContext::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Bundle\\Block\\Catalog\\Product\\View\\Type\\Bundle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Bundle\\Block\\Catalog\\Product\\View\\Type\\Bundle::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Helper\\Product\\Flat\\Indexer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Helper\\Product\\Flat\\Indexer::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Config::$`}{`_`}{`storeManager`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Indexer\\Category\\Product\\AbstractAction`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Indexer\\Category\\Product\\AbstractAction::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Layer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Layer::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Layer\\Resolver`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Layer\\Resolver::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Product`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Product::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Product\\Media\\Config`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Product\\Media\\Config::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Product\\Option\\Type\\DefaultType`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Product\\Option\\Type\\DefaultType::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Product\\Type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Product\\Type::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Product\\Type\\Price`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Product\\Type\\Price::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\ResourceModel\\Product`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogImportExport\\Model\\Export\\Product::$`}{`_`}{`storeIdToCode`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Config\\App\\Config\\Type\\System::`}{`_`}{`_`}{`debugInfo`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Config\\App\\Config\\Type\\System::cleanAndWarmDefaultScopeData`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Config\\App\\Config\\Type\\System::loadDefaultScopeData`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[private]`}{` Removed last method parameter(s).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Config\\Model\\ResourceModel\\Config::`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Added optional parameter(s).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ConfigurableProduct\\Model\\Product\\Type\\Configurable`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ConfigurableProduct\\Model\\Product\\Type\\Configurable::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ConfigurableProduct\\Model\\Product\\VariationHandler`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ConfigurableProduct\\Model\\Product\\VariationHandler::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Csp\\Block\\Sri\\Hashes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Helper\\Address`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Helper\\Address::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Model\\Address\\AbstractAddress`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Model\\Address\\AbstractAddress::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Model\\Customer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Model\\Customer::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Model\\CustomerRegistry`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Model\\CustomerRegistry::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\DataExporter\\Model\\Indexer\\FeedIndexer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Directory\\Helper\\Data`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Directory\\Helper\\Data::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Directory\\Model\\Country`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Directory\\Model\\Country::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Directory\\Model\\Currency`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Directory\\Model\\Currency::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Directory\\Model\\ResourceModel\\Currency`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Directory\\Model\\ResourceModel\\Currency::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Eav\\Model\\Config`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Eav\\Model\\Config::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Eav\\Model\\Config::$`}{`_`}{`storeManager`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Eav\\Model\\Config::getWebsiteId`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Removed last method parameter(s).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Eav\\Model\\Config::getWebsiteId`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Method visibility has been changed to higher lever from `}{`[private]`}{` to `}{`[public]`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Eav\\Model\\Entity\\AbstractEntity`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Eav\\Model\\Entity\\AbstractEntity::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Eav\\Model\\Entity\\Attribute\\AbstractAttribute`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Eav\\Model\\Entity\\Attribute\\AbstractAttribute::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Eav\\Model\\Entity\\Attribute\\Source\\Table`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Eav\\Model\\Entity\\Attribute\\Source\\Table::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch\\ElasticAdapter\\SearchAdapter\\Mapper`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch\\ElasticAdapter\\SearchAdapter\\Query\\Builder`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch\\SearchAdapter\\Mapper`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Acl\\Builder`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Acl\\Builder::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\ActionFlag`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\ActionFlag::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\AreaList`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\AreaList::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\DeploymentConfig::`}{`_`}{`_`}{`debugInfo`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Http\\Context`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Http\\Context::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Request\\Http`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Request\\Http::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\ResourceConnection`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\ResourceConnection::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Config\\ConfigOptionsListConstants::STORE`}{`_`}{`KEY`}{`_`}{`ENCODED`}{`_`}{`RANDOM`}{`_`}{`STRING`}{`_`}{`PREFIX`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Constant has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Config\\Data::`}{`_`}{`_`}{`debugInfo`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Config\\Data\\Scoped::$`}{`_`}{`cache`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Config\\Data\\Scoped::$`}{`_`}{`cacheId`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Config\\Data\\Scoped::$`}{`_`}{`reader`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Console\\Cli::getDefaultCommands`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Data\\Collection`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Data\\Collection::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DataObject::`}{`_`}{`_`}{`debugInfo`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DB\\Adapter\\Pdo\\Mysql`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DB\\Adapter\\Pdo\\Mysql::`}{`_`}{`_`}{`debugInfo`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DB\\Adapter\\Pdo\\Mysql::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Filesystem\\Directory\\Read::`}{`_`}{`_`}{`debugInfo`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Filesystem\\DirectoryList::`}{`_`}{`_`}{`debugInfo`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Exception\\GraphQlNoSuchEntityException`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Exception\\GraphQlNoSuchEntityException::getExtensions`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Query\\Resolver\\BatchResponse`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Query\\Resolver\\BatchResponse::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\HTTP\\PhpEnvironment\\RemoteAddress`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\HTTP\\PhpEnvironment\\RemoteAddress::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Indexer\\IndexerRegistry`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Indexer\\IndexerRegistry::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Logger\\Handler\\Base`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Logger\\Handler\\Base::`}{`_`}{`_`}{`debugInfo`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Logger\\Handler\\Base::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Math\\Random::getRandomBytes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Mview\\View\\ChangeLogBatchWalker`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class has been renamed to Magento\\Framework\\Mview\\View\\ChangelogBatchWalker.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Pricing\\Price\\Collection`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Pricing\\Price\\Collection::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Registry`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Registry::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Search\\Request\\Builder`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Search\\Request\\Builder::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Search\\Request\\Cleaner`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Search\\Request\\Cleaner::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\AbstractValidator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\AbstractValidator::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Asset\\Minification`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Asset\\Minification::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Asset\\Repository`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Asset\\Repository::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\AbstractBlock::CUSTOM`}{`_`}{`CACHE`}{`_`}{`KEY`}{`_`}{`PREFIX`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Constant has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Webapi\\Exception::HTTP`}{`_`}{`TOO`}{`_`}{`MANY`}{`_`}{`REQUESTS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Constant has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Webapi\\ServiceInputProcessor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Webapi\\ServiceInputProcessor::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GraphQlServer\\Model\\UrlProvider`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\Export\\Entity\\AbstractEntity::$`}{`_`}{`storeIdToCode`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PageCache\\Model\\Varnish\\VclGenerator::generateVcl`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Added optional parameter(s).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesBase\\Block\\Adminhtml\\System\\Config\\Fieldset\\Child`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesBase\\Block\\Adminhtml\\System\\Config\\Fieldset\\Payment`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesDashboard\\Block\\Adminhtml\\Index`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesDashboard\\Block\\Adminhtml\\System\\Config\\MagentoPaymentsButton`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesDashboard\\Block\\Adminhtml\\System\\Config\\MagentoPaymentsRedirect`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesPaypal\\Block\\Cart\\ValidationMessages`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesPaypal\\Block\\Customer\\CardRenderer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesPaypal\\Block\\Info`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesPaypal\\Block\\Message`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesPaypal\\Block\\SmartButtons`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesPaypal\\Block\\SmartButtons\\Review`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesPaypal\\Block\\SmartButtons\\Review\\Details`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesPaypal\\Block\\SmartButtonsCart`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesPaypal\\Block\\SmartButtonsProduct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesPaypal\\Model\\Api\\Data\\PaymentOrder`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesPaypal\\Model\\Api\\PaymentOrderRequest`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesPaypal\\Model\\Api\\PaymentSdkRequest`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Quote\\Model\\Quote\\Address::setBaseDiscountAmount`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Quote\\Model\\Quote\\Address\\Total\\AbstractTotal`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Quote\\Model\\Quote\\Address\\Total\\AbstractTotal::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\SaaSCommon\\Model\\ResyncManager`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\Config`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\Config::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\Email\\Container\\Container`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\Email\\Container\\Container::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\ResourceModel\\EntityAbstract`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\ResourceModel\\EntityAbstract::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\SalesRule\\Model\\ResourceModel\\Rule\\Collection::setValidationFilter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Added optional parameter(s).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\SalesRule\\Model\\Rule::getSimpleAction`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\SalesSequence\\Model\\Builder`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\SalesSequence\\Model\\Builder::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ServicesIdLayout\\Block\\Adminhtml\\Index`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Shipping\\Model\\Carrier\\AbstractCarrier::$`}{`_`}{`result`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Store\\Model\\App\\Emulation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Store\\Model\\App\\Emulation::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Store\\Model\\Store`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Store\\Model\\Store::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Weee\\Helper\\Data`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Weee\\Helper\\Data::`}{`_`}{`resetState`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "ce-246-247-interface"
    }}>{`Interface changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Api\\ProductAttributeIsFilterableManagementInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Indexer\\StateInterface::STATUS`}{`_`}{`SUSPENDED`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Constant has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Mview\\View\\ChangeLogBatchWalkerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been renamed to Magento\\Framework\\Mview\\View\\ChangelogBatchWalkerInterface.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\ObjectManager\\ResetAfterRequestInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\InventorySalesApi\\Model\\GetStockItemsDataInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PageCache\\Model\\VclGeneratorInterface::generateVcl`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Added optional parameter(s).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PageCache\\Model\\VclTemplateLocatorInterface::getTemplate`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Added optional parameter(s).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesPaypal\\Api\\Data\\PaymentOrderDetailsInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesPaypal\\Api\\Data\\PaymentOrderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesPaypal\\Api\\Data\\PaymentSdkParamsInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesPaypal\\Api\\PaymentConfigManagementInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesPaypal\\Api\\PaymentOrderRequestInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PaymentServicesPaypal\\Api\\PaymentSdkRequestInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\SaaSCommon\\Model\\Http\\ConverterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ServicesId\\Model\\ServicesClientInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ServicesId\\Model\\ServicesConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Vault\\Api\\Data\\PaymentTokenInterface::getWebsiteId`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Vault\\Api\\Data\\PaymentTokenInterface::setWebsiteId`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Vault\\Api\\Data\\PaymentTokenInterface::WEBSITE`}{`_`}{`ID`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Constant has been added.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "ce-246-247-database"
    }}>{`Database changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`data`}{`_`}{`exporter`}{`_`}{`uuid`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Table was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment`}{`_`}{`services`}{`_`}{`order`}{`_`}{`data`}{`_`}{`production`}{`_`}{`submitted`}{`_`}{`hash`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Table was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment`}{`_`}{`services`}{`_`}{`order`}{`_`}{`data`}{`_`}{`sandbox`}{`_`}{`submitted`}{`_`}{`hash`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Table was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment`}{`_`}{`services`}{`_`}{`order`}{`_`}{`status`}{`_`}{`data`}{`_`}{`production`}{`_`}{`submitted`}{`_`}{`hash`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Table was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment`}{`_`}{`services`}{`_`}{`order`}{`_`}{`status`}{`_`}{`data`}{`_`}{`sandbox`}{`_`}{`submitted`}{`_`}{`hash`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Table was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment`}{`_`}{`services`}{`_`}{`store`}{`_`}{`data`}{`_`}{`production`}{`_`}{`submitted`}{`_`}{`hash`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Table was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment`}{`_`}{`services`}{`_`}{`store`}{`_`}{`data`}{`_`}{`sandbox`}{`_`}{`submitted`}{`_`}{`hash`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Table was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`sales`}{`_`}{`data`}{`_`}{`exporter`}{`_`}{`order`}{`_`}{`statuses`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Table was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`sales`}{`_`}{`data`}{`_`}{`exporter`}{`_`}{`orders`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Table was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`stores`}{`_`}{`data`}{`_`}{`exporter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Table was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`vault`}{`_`}{`payment`}{`_`}{`token/website`}{`_`}{`id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Column was added`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "ce-246-247-di"
    }}>{`Di changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch\\Setup\\InstallConfig`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Virtual Type was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`elasticsearch5DynamicFieldProvider`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Virtual Type was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`elasticsearch5FieldNameDefaultResolver`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Virtual Type was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`elasticsearch5FieldNameResolver`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Virtual Type was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`elasticsearch5FieldTypeDateTimeResolver`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Virtual Type was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`elasticsearch5FieldTypeDefaultResolver`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Virtual Type was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`elasticsearch5FieldTypeFloatResolver`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Virtual Type was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`elasticsearch5StaticFieldProvider`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Virtual Type was removed`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "ce-246-247-system"
    }}>{`System changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`carriers/fedex/api`}{`_`}{`key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`carriers/fedex/dropoff`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`carriers/fedex/key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`carriers/fedex/meter`}{`_`}{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`carriers/fedex/password`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`carriers/fedex/pickup`}{`_`}{`type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`carriers/fedex/secret`}{`_`}{`key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`carriers/ups/gateway`}{`_`}{`rest`}{`_`}{`url`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`carriers/ups/tracking`}{`_`}{`rest`}{`_`}{`url`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`carriers/ups/tracking`}{`_`}{`url`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`carriers/ups/tracking`}{`_`}{`xml`}{`_`}{`url`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/elasticsearch5`}{`_`}{`enable`}{`_`}{`auth`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/elasticsearch5`}{`_`}{`index`}{`_`}{`prefix`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/elasticsearch5`}{`_`}{`minimum`}{`_`}{`should`}{`_`}{`match`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/elasticsearch5`}{`_`}{`password`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/elasticsearch5`}{`_`}{`server`}{`_`}{`hostname`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/elasticsearch5`}{`_`}{`server`}{`_`}{`port`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/elasticsearch5`}{`_`}{`server`}{`_`}{`timeout`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/elasticsearch5`}{`_`}{`test`}{`_`}{`connect`}{`_`}{`wizard`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/elasticsearch5`}{`_`}{`username`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkout/options/enable`}{`_`}{`guest`}{`_`}{`checkout`}{`_`}{`login`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`csp`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A section-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`csp/mode`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`csp/mode/admin`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`csp/mode/admin/report`}{`_`}{`uri`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`csp/mode/admin`}{`_`}{`sales`}{`_`}{`order`}{`_`}{`create`}{`_`}{`index`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`csp/mode/admin`}{`_`}{`sales`}{`_`}{`order`}{`_`}{`create`}{`_`}{`index/report`}{`_`}{`uri`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`csp/mode/storefront`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`csp/mode/storefront/report`}{`_`}{`uri`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`csp/mode/storefront`}{`_`}{`checkout`}{`_`}{`index`}{`_`}{`index`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`csp/mode/storefront`}{`_`}{`checkout`}{`_`}{`index`}{`_`}{`index/report`}{`_`}{`uri`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/apple`}{`_`}{`pay`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/apple`}{`_`}{`pay/debug`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/apple`}{`_`}{`pay/display`}{`_`}{`buttons`}{`_`}{`cart`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/apple`}{`_`}{`pay/display`}{`_`}{`buttons`}{`_`}{`checkout`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/apple`}{`_`}{`pay/display`}{`_`}{`buttons`}{`_`}{`minicart`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/apple`}{`_`}{`pay/display`}{`_`}{`buttons`}{`_`}{`product`}{`_`}{`detail`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/apple`}{`_`}{`pay/payment`}{`_`}{`action`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/apple`}{`_`}{`pay/sort`}{`_`}{`order`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/apple`}{`_`}{`pay/title`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/button`}{`_`}{`style`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/button`}{`_`}{`style/style`}{`_`}{`color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/button`}{`_`}{`style/style`}{`_`}{`height`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/button`}{`_`}{`style/style`}{`_`}{`height`}{`_`}{`use`}{`_`}{`default`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/button`}{`_`}{`style/style`}{`_`}{`label`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/button`}{`_`}{`style/style`}{`_`}{`layout`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/button`}{`_`}{`style/style`}{`_`}{`shape`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/button`}{`_`}{`style/style`}{`_`}{`tagline`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/general`}{`_`}{`configuration`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/general`}{`_`}{`configuration/active`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/general`}{`_`}{`configuration/async`}{`_`}{`status`}{`_`}{`updates`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/general`}{`_`}{`configuration/method`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/general`}{`_`}{`configuration/production`}{`_`}{`merchant`}{`_`}{`id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/general`}{`_`}{`configuration/sandbox`}{`_`}{`merchant`}{`_`}{`id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/general`}{`_`}{`configuration/soft`}{`_`}{`descriptor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/google`}{`_`}{`pay`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/google`}{`_`}{`pay/button`}{`_`}{`color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/google`}{`_`}{`pay/button`}{`_`}{`type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/google`}{`_`}{`pay/debug`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/google`}{`_`}{`pay/display`}{`_`}{`buttons`}{`_`}{`cart`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/google`}{`_`}{`pay/display`}{`_`}{`buttons`}{`_`}{`checkout`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/google`}{`_`}{`pay/display`}{`_`}{`buttons`}{`_`}{`minicart`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/google`}{`_`}{`pay/display`}{`_`}{`buttons`}{`_`}{`product`}{`_`}{`detail`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/google`}{`_`}{`pay/payment`}{`_`}{`action`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/google`}{`_`}{`pay/sort`}{`_`}{`order`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/google`}{`_`}{`pay/title`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/hosted`}{`_`}{`fields`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/hosted`}{`_`}{`fields/debug`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/hosted`}{`_`}{`fields/display`}{`_`}{`on`}{`_`}{`checkout`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/hosted`}{`_`}{`fields/payment`}{`_`}{`action`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/hosted`}{`_`}{`fields/sort`}{`_`}{`order`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/hosted`}{`_`}{`fields/three`}{`_`}{`ds`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/hosted`}{`_`}{`fields/title`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/hosted`}{`_`}{`fields/vault`}{`_`}{`active`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/hosted`}{`_`}{`fields/vault`}{`_`}{`active`}{`_`}{`admin`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/legacy`}{`_`}{`admin`}{`_`}{`enabled`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/magento`}{`_`}{`payments`}{`_`}{`button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/smart`}{`_`}{`buttons`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/smart`}{`_`}{`buttons/debug`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/smart`}{`_`}{`buttons/display`}{`_`}{`buttons`}{`_`}{`cart`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/smart`}{`_`}{`buttons/display`}{`_`}{`buttons`}{`_`}{`checkout`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/smart`}{`_`}{`buttons/display`}{`_`}{`buttons`}{`_`}{`minicart`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/smart`}{`_`}{`buttons/display`}{`_`}{`buttons`}{`_`}{`product`}{`_`}{`detail`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/smart`}{`_`}{`buttons/display`}{`_`}{`paylater`}{`_`}{`message`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/smart`}{`_`}{`buttons/funding`}{`_`}{`card`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/smart`}{`_`}{`buttons/funding`}{`_`}{`paypal`}{`_`}{`credit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/smart`}{`_`}{`buttons/funding`}{`_`}{`venmo`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/smart`}{`_`}{`buttons/payment`}{`_`}{`action`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/smart`}{`_`}{`buttons/sort`}{`_`}{`order`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`payment/recommended`}{`_`}{`solutions/magento`}{`_`}{`payments`}{`_`}{`legacy/smart`}{`_`}{`buttons/title`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`promo/auto`}{`_`}{`generated`}{`_`}{`coupon`}{`_`}{`codes/quantity`}{`_`}{`limit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`sales/backpressure`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`sales/backpressure/enabled`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`sales/backpressure/guest`}{`_`}{`limit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`sales/backpressure/limit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`sales/backpressure/period`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`sales/cancellation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`sales/cancellation/enabled`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`sales/cancellation/reasons`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`services`}{`_`}{`connector`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A section-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`services`}{`_`}{`connector/services`}{`_`}{`connector`}{`_`}{`integration`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`services`}{`_`}{`connector/services`}{`_`}{`connector`}{`_`}{`integration/production`}{`_`}{`api`}{`_`}{`key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`services`}{`_`}{`connector/services`}{`_`}{`connector`}{`_`}{`integration/production`}{`_`}{`private`}{`_`}{`key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`services`}{`_`}{`connector/services`}{`_`}{`connector`}{`_`}{`integration/sandbox`}{`_`}{`api`}{`_`}{`key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`services`}{`_`}{`connector/services`}{`_`}{`connector`}{`_`}{`integration/sandbox`}{`_`}{`private`}{`_`}{`key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`services`}{`_`}{`connector/services`}{`_`}{`id`}{`_`}{`onboarding`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`services`}{`_`}{`connector/services`}{`_`}{`id`}{`_`}{`onboarding/initiate`}{`_`}{`onboarding`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`system/full`}{`_`}{`page`}{`_`}{`cache/handles`}{`_`}{`size`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`system/full`}{`_`}{`page`}{`_`}{`cache/varnish/export`}{`_`}{`button`}{`_`}{`version4`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`system/full`}{`_`}{`page`}{`_`}{`cache/varnish/export`}{`_`}{`button`}{`_`}{`version5`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "ce-246-247-xsd"
    }}>{`Xsd changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`/app/code/module-data-exporter/etc/et`}{`_`}{`schema.xsd`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A schema declaration was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`/app/code/module-query-xml/etc/query.xsd`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A schema declaration was added`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "ce-246-247-etSchema"
    }}>{`EtSchema changes`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`CreditMemo`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Added a new declaration for record CreditMemo.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Export`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Added a new declaration for record Export.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Invoice`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Added a new declaration for record Invoice.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Order`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Added a new declaration for record Order.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`OrderItem`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Added a new declaration for record OrderItem.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`OrderStatus`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Added a new declaration for record OrderStatus.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Transaction`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Added a new declaration for record Transaction.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "ce-246-247-class-api-membership"
    }}>{`Class API membership changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Block\\Adminhtml\\Form`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch\\Elasticsearch5\\SearchAdapter\\Mapper`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch\\Elasticsearch5\\SearchAdapter\\Query\\Builder`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Api\\AbstractSimpleObjectBuilder`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Cache\\Frontend\\Decorator\\Bare`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Data\\Form\\Element\\Editor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Data\\Structure`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\HTTP\\PhpEnvironment\\Request`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\HTTP\\PhpEnvironment\\Response`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Locale\\Resolver`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\ObjectManager\\ObjectManager`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Session\\SessionManager`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Url`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Asset\\Collection`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Webapi\\Request`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Review\\Block\\Product\\View`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\SalesRule\\Model\\Validator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Block\\Adminhtml\\Order\\Create\\Form\\AbstractForm`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Block\\Adminhtml\\Order\\Create\\Form\\Address`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Block\\Items\\AbstractItems`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\ResourceModel\\Order\\Collection\\AbstractCollection`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      